import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "closet-home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "나의 옷장"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "내 몸에 딱 맞는 사이즈를 기록하고 관리하세요")
], -1)
const _hoisted_3 = { class: "community-section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "브리저 옷장 현황", -1)
const _hoisted_5 = { class: "cs-kpis" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "cs-sk cs-sk-val" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "cs-sk cs-sk-label" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "cs-kpi" }
const _hoisted_10 = { class: "cs-value" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "벌", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "cs-label" }, "등록된 의류", -1)
const _hoisted_13 = { class: "cs-kpi" }
const _hoisted_14 = { class: "cs-value" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "명", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "cs-label" }, "기록 중인 사용자", -1)
const _hoisted_17 = { class: "cs-kpi" }
const _hoisted_18 = { class: "cs-value" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "개", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "cs-label" }, "기록된 브랜드", -1)
const _hoisted_21 = {
  key: 0,
  class: "cs-grid"
}
const _hoisted_22 = { class: "cs-card" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "cs-card-title" }, "카테고리별 등록", -1)
const _hoisted_24 = { class: "dist-list" }
const _hoisted_25 = { class: "dist-label" }
const _hoisted_26 = { class: "dist-bar-wrap" }
const _hoisted_27 = { class: "dist-val" }
const _hoisted_28 = {
  key: 0,
  class: "dist-empty"
}
const _hoisted_29 = { class: "cs-card" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "cs-card-title" }, [
  /*#__PURE__*/_createTextVNode("사용자 분포 "),
  /*#__PURE__*/_createElementVNode("span", { class: "cs-sub" }, "성별·연령대")
], -1)
const _hoisted_31 = { class: "pill-rows" }
const _hoisted_32 = {
  key: 0,
  class: "pill-row"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "pill-cap" }, "성별", -1)
const _hoisted_34 = {
  key: 1,
  class: "pill-row"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "pill-cap" }, "연령대", -1)
const _hoisted_36 = {
  key: 2,
  class: "dist-empty"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "cs-card-title tb" }, "인기 브랜드", -1)
const _hoisted_38 = { class: "brand-chips" }
const _hoisted_39 = { class: "rank" }
const _hoisted_40 = {
  key: 0,
  class: "dist-empty"
}
const _hoisted_41 = {
  key: 0,
  class: "my-section"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "내 옷장 요약", -1)
const _hoisted_43 = { class: "my-grid" }
const _hoisted_44 = { class: "my-card" }
const _hoisted_45 = { class: "my-kpis" }
const _hoisted_46 = { class: "my-kpi" }
const _hoisted_47 = { class: "mk-value" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, "벌", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "mk-label" }, "내 의류", -1)
const _hoisted_50 = { class: "my-kpi" }
const _hoisted_51 = { class: "mk-value" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", null, "개", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "mk-label" }, "브랜드", -1)
const _hoisted_54 = { class: "my-kpi" }
const _hoisted_55 = { class: "mk-value" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", null, "벌", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "mk-label" }, "딱 맞음", -1)
const _hoisted_58 = {
  key: 0,
  class: "my-kpi"
}
const _hoisted_59 = { class: "mk-value" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", null, "cm", -1)
const _hoisted_61 = { class: "mk-label" }
const _hoisted_62 = { class: "quick-actions" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "qa-ic" }, "👕", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "qa-t" }, "의류 등록", -1)
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "qa-ic" }, "🗄️", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "qa-t" }, "옷장 열기", -1)
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "qa-ic" }, "🔎", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "qa-t" }, "사이즈 가이드", -1)
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "qa-ic" }, "📏", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "qa-t" }, "신체정보", -1)
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = { class: "my-card recent" }
const _hoisted_76 = { class: "my-card-head" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", null, "최근 등록 의류", -1)
const _hoisted_78 = {
  key: 0,
  class: "my-empty"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("p", null, "아직 등록한 의류가 없어요", -1)
const _hoisted_80 = {
  key: 1,
  class: "recent-list"
}
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "ri-cat" }
const _hoisted_83 = { class: "ri-brand" }
const _hoisted_84 = { class: "ri-name" }
const _hoisted_85 = {
  key: 0,
  class: "ri-size"
}
const _hoisted_86 = {
  key: 1,
  class: "cta-section"
}
const _hoisted_87 = { class: "cta-card" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "cta-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cta-title" }, "내 옷장도 만들어 보세요"),
  /*#__PURE__*/_createElementVNode("div", { class: "cta-desc" }, " 산 옷의 브랜드·사이즈·실측·핏을 기록하면, 재구매 때 바로 참고하고 나에게 맞는 사이즈도 추천받을 수 있어요. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_ctx.statsLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
              return _createElementVNode("div", {
                class: "cs-kpi",
                key: 'sk'+n
              }, _hoisted_8)
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.pub.totalClothing.toLocaleString()), 1),
                  _hoisted_11
                ]),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_ctx.pub.totalUsers.toLocaleString()), 1),
                  _hoisted_15
                ]),
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_ctx.pub.totalBrands.toLocaleString()), 1),
                  _hoisted_19
                ]),
                _hoisted_20
              ])
            ], 64))
      ]),
      (!_ctx.statsLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryDist, (c) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "dist-row",
                    key: c.label
                  }, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(c.label), 1),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", {
                        class: "dist-bar",
                        style: _normalizeStyle({ width: c.ratio + '%' })
                      }, null, 4)
                    ]),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(c.count) + "벌", 1)
                  ]))
                }), 128)),
                (_ctx.categoryDist.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, "데이터 없음"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                (_ctx.genderDist.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _hoisted_33,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderDist, (g) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "stat-pill",
                          key: g.label
                        }, [
                          _createTextVNode(_toDisplayString(g.label) + " ", 1),
                          _createElementVNode("b", null, _toDisplayString(g.count), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.ageDist.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _hoisted_35,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ageDist, (a) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "stat-pill",
                          key: a.label
                        }, [
                          _createTextVNode(_toDisplayString(a.label) + " ", 1),
                          _createElementVNode("b", null, _toDisplayString(a.count), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.genderDist.length && !_ctx.ageDist.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "데이터 없음"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pub.topBrands, (b, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "brand-chip",
                    key: b.brandName
                  }, [
                    _createElementVNode("em", _hoisted_39, _toDisplayString(i + 1), 1),
                    _createTextVNode(_toDisplayString(b.brandName) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(b.count) + "벌", 1)
                  ]))
                }), 128)),
                (!_ctx.pub.topBrands || _ctx.pub.topBrands.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, "데이터 없음"))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("section", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createTextVNode(_toDisplayString(_ctx.allClothingList.length), 1),
                    _hoisted_48
                  ]),
                  _hoisted_49
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createTextVNode(_toDisplayString(_ctx.myBrandCount), 1),
                    _hoisted_52
                  ]),
                  _hoisted_53
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createTextVNode(_toDisplayString(_ctx.perfectCount), 1),
                    _hoisted_56
                  ]),
                  _hoisted_57
                ]),
                (_ctx.hasBodyData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createTextVNode(_toDisplayString(_ctx.bodyData.height || '-'), 1),
                        _hoisted_60
                      ]),
                      _createElementVNode("div", _hoisted_61, "키 · " + _toDisplayString(_ctx.bodyData.weight || '-') + "kg", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("button", {
                  class: "qa-btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToClothingRegister && _ctx.goToClothingRegister(...args)))
                }, _hoisted_65),
                _createElementVNode("button", {
                  class: "qa-btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToWardrobe && _ctx.goToWardrobe(...args)))
                }, _hoisted_68),
                _createElementVNode("button", {
                  class: "qa-btn",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToGuide && _ctx.goToGuide(...args)))
                }, _hoisted_71),
                _createElementVNode("button", {
                  class: "qa-btn",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToBody && _ctx.goToBody(...args)))
                }, _hoisted_74)
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                (_ctx.recentClothingList.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "more-link",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToWardrobe && _ctx.goToWardrobe(...args)))
                    }, "더보기"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.recentClothingList.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("button", {
                      class: "btn-register",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToClothingRegister && _ctx.goToClothingRegister(...args)))
                    }, "첫 의류 등록하기")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentClothingList, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "recent-item",
                        key: item.id,
                        onClick: ($event: any) => (_ctx.goToClothingDetail(item.id))
                      }, [
                        _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.getCategoryLabel(item.category)), 1),
                        _createElementVNode("span", _hoisted_83, _toDisplayString(item.brandName || '-'), 1),
                        _createElementVNode("span", _hoisted_84, _toDisplayString(item.productName || item.subCategory || ''), 1),
                        (item.labeledSize)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(item.labeledSize), 1))
                          : _createCommentVNode("", true),
                        (item.fitFeedback)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(["ri-fit", _ctx.fitClass(item.fitFeedback)])
                            }, _toDisplayString(_ctx.getFitFeedbackLabel(item.fitFeedback)), 3))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_81))
                    }), 128))
                  ]))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _hoisted_88,
            _createElementVNode("button", {
              class: "cta-btn",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args)))
            }, "시작하기")
          ])
        ]))
  ]))
}